import React from "react";
import { Modal } from "antd";
import EwaybillDTO from "@/dto/order/EwaybillDTO";
import { getEwaybillRealLogisticsCompanyNode } from "@/utils/EwaybillUtil";

interface ShowCancelErrorDialogParams {
    ewaybills: EwaybillDTO[];
    errorMap: any;
    successfulCount?: number;
    failCount?: number;
}

export default function showCancelErrorDialog({
    ewaybills,
    errorMap,
    successfulCount = 0,
    failCount = 0,
}: ShowCancelErrorDialogParams) {
    const errorComponents: any = [];

    ewaybills.forEach((ewaybill) => {
        const error = errorMap[ewaybill.id];

        if (error) {
            const { waybillNo } = ewaybill;

            errorComponents.push(
                <p key={ewaybill.id}>
                    [{getEwaybillRealLogisticsCompanyNode(ewaybill)}] {waybillNo} : {error}
                </p>,
            );
        }
    });

    Modal.error({
        title: "回收电子面单号失败",
        width: 600,
        content: (
            <div>
                <p>
                    回收成功{successfulCount}个。回收失败{failCount}个
                </p>
                {errorComponents}
            </div>
        ),
    });
}
